import { render, staticRenderFns } from "./return-report.vue?vue&type=template&id=35bf4841&"
import script from "./return-report.vue?vue&type=script&lang=js&"
export * from "./return-report.vue?vue&type=script&lang=js&"
import style0 from "./return-report.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports